// @flow
export const pastFilterOptions = {
    ALL: 'ALL',
    LOST: 'LOST',
    WON: 'WON',
};

export const upcomingFilterOptions = {
    ALL: 'ALL',
    LEADING: 'LEADING',
    OUTBID: 'OUTBID',
};

export default { ...pastFilterOptions, ...upcomingFilterOptions };
